import userActionTypes from "./user.types";

export const signinStart = () => ({
  type: userActionTypes.SIGNIN_START,
});

export const signInSuccess = (user) => ({
  type: userActionTypes.SIGNIN_SUCCESS,
  payload: user,
});

export const startLoading = () => ({
  type: userActionTypes.START_LOADING,
});

export const stopLoading = () => ({
  type: userActionTypes.STOP_LOADING,
});

export const setIsUserVerified = (isVerified) => ({
  type: userActionTypes.SET_IS_VERIFIED,
  payload: isVerified,
});

export const setAccessToken = (accessToken) => ({
  type: userActionTypes.SET_ACCESS_TOKEN,
  payload: accessToken,
});

export const signInFailure = (error) => ({
  type: userActionTypes.SIGNIN_FAILURE,
  payload: error,
});

export const signoutStart = () => ({
  type: userActionTypes.SIGNOUT_START,
});

export const signoutSuccess = () => ({
  type: userActionTypes.SIGNOUT_SUCCESS,
});

export const signoutFailure = (error) => ({
  type: userActionTypes.SIGNOUT_FAILURE,
  payload: error,
});

export const setUserLoader = (status) => ({
  type: userActionTypes.SET_USER_LOADER,
  payload: status,
});

export const setMfaStatus = (status) => ({
  type: userActionTypes.SET_MFA_STATUS,
  payload: status,
});

export const setQrCodeData = (status) => ({
  type: userActionTypes.SET_QR_CODE_DATA,
  payload: status,
});

export const setQrCodeLoader = (status) => ({
  type: userActionTypes.SET_QR_CODE_LOADER,
  payload: status,
});

export const setUserName = (userName) => ({
  type: userActionTypes.SET_USER_NAME,
  payload: userName,
});

export const setUserEmail = (userEmail) => ({
  type: userActionTypes.SET_USER_EMAIL,
  payload: userEmail,
});

export const setUserPermission = (userPermission) => ({
  type: userActionTypes.SET_USER_PERMISSION,
  payload: userPermission,
});

export const setCorpDetails = (corpName, corpId) => ({
  type: userActionTypes.SET_CORP_DETAILS,
  payloadName: corpName,
  payloadId: corpId,
});

export const resetRedux = () => ({
  type: userActionTypes.RESET_REDUX,
});